export default
{
    /**
     * Uppercase the first character of a string and lowercase the rest.
     *
     * @param {String} str The string to capitalize.
     * @returns {String}
     */
    capitalize(str = '')
    {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },

    /**
     * Uppercase the first letter of a string.
     *
     * @param {String} str The string to capitalize.
     * @returns {String}
     */
    capitalizeFirstLetter(str = '')
    {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },

    /**
     * Uppercase the fist letter of every word in a string.
     *
     * @param {String} str The string to capitalize.
     * @returns {String}
     */
    capitalizeAllWords(str = '')
    {
        return str.split(' ').map(word => this.capitalize(word)).join(' ');
    },
};
